import { Button } from "@studyplus/boron-ui";
import { ConfirmUpdateTypeModal } from "../../../containers/pages/StudentsCalendar/ConfirmUpdateTypeModal";
import { UpdateType } from "../../../domains/Schedule";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import SectionInterface from "../../../interfaces/SectionInterface";
import {
  SectionScheduleMutateParam,
  useMutateSectionSchedule,
} from "../SectionScheduleForm/useMutateSectionSchedule";

type Props = {
  section: SectionInterface;
  formValues: SectionScheduleMutateParam;
  onClose: () => void;
};

export const ConfirmFromForm = ({ section, formValues, onClose }: Props) => {
  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const { mutate, isPending } = useMutateSectionSchedule({
    section,
    onSuccess() {
      showSuccessMessage("予定を登録しました");
      onClose();
    },
    onError() {
      showErrorMessage("予定の登録に失敗しました");
    },
  });

  const handleUpdate = (updateType: UpdateType) => {
    mutate({
      ...formValues,
      updateType,
    });
  };

  return (
    <ConfirmUpdateTypeModal
      headerLabel="繰り返し予定の変更"
      onClose={onClose}
      buttonsArea={(chosen) => (
        <div>
          <Button
            disabled={isPending}
            isLoading={isPending}
            onClick={() => handleUpdate(chosen)}
          >
            保存
          </Button>
        </div>
      )}
    />
  );
};
